import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Paper, Button, TextField, FormControl, InputLabel, Typography, Select, MenuItem } from '@material-ui/core';
import { insertInvoice } from '../../../redux/actions/tracker/invoiceActions';
import { getAuthUser } from '../../../redux/actions/authActions';
import { WorkflowGetList } from '../../../redux/actions/tracker/workflowActions';

const styles = {
  btnInsert: {
    'margin-top': '5%',
  },
  paper: {
    width: '50%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginTop: 20,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 20,
    width: 200,
  },
  menu: {
    width: 200,
  },
};

class InvoiceCreate extends Component {

  static propTypes = {
    data: PropTypes.any,
  };

  constructor(props) {

    super(props);
    this.insertInvoice = this.insertInvoice.bind(this);

    this.state = {
      workflowId: 0,
      companyId: 0,
      userId: 0,
      codeBar: '',
      invoiceNumber: '',
      expiration: '',
      workflows: [],
    };

  }

  componentWillMount = () => {

    const holdingId = this.props.user.context.idHolding;

    WorkflowGetList(holdingId).then(workflows => this.setState({ workflows }));

  }

  insertInvoice(event) {

    const user = getAuthUser();
    const params = this.state;

    const payload = {

      workflowId: params.workflowId,
      companyId: user.context.idCompany,
      userId: user.IdUser,
      codeBar: params.codeBar,
      invoiceNumber: params.invoiceNumber,
      expiration: params.expiration,

    };

    event.preventDefault();

    insertInvoice(payload).then(() => {

      alert('Inserido');
      this.props.history.push('/invoice/search');

    }, (e) => {

      alert('falha');

    });

  }

  handleChange = name => (event) => {

    this.setState({
      [name]: event.target.value,
    });

  };

  isValid = () => {

    const { codeBar, invoiceNumber, workflowId, expiration } = this.state;

    return (
      !(codeBar && invoiceNumber && workflowId && expiration)
    );

  }

  render() {

    const { codeBar, invoiceNumber, workflowId, expiration, workflows } = this.state;

    return (
      <div>
        <Typography variant="display1" gutterBottom>
          Inserir Nota
        </Typography>
        <Paper>
          <TextField
            id="invoiceNumber"
            label="Numero da nota"
            value={invoiceNumber}
            onChange={this.handleChange('invoiceNumber')}
            style={styles.textField}
            margin="normal"
            autoComplete="true"
          />
          <TextField
            id="codeBar"
            label="Codigo de Barras"
            value={codeBar}
            onChange={this.handleChange('codeBar')}
            style={styles.textField}
            margin="normal"
            autoComplete="true"
          />
          <br />
          <FormControl style={styles.textField}>
            <InputLabel htmlFor="workflowId">WorkFlow</InputLabel>
            <Select
              value={workflowId}
              onChange={this.handleChange('workflowId')}
              name="workflowId"
            >
              {workflows.map(item =>
                <MenuItem value={item.workFlowId}>{item.name}</MenuItem>
              )}
            </Select>
          </FormControl>
          <TextField
            id="expiration"
            label={`${I18n.t('fields.expiration_time')}  (${I18n.t('fields.in_hours')})`}
            value={expiration}
            onChange={this.handleChange('expiration')}
            style={styles.textField}
            margin="normal"
            autoComplete="true"
            type="number"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={this.insertInvoice}
            disabled={this.isValid()}
          >
            Inserir
          </Button>
        </Paper>
      </div>
    );

  }

}

export default withRouter(InvoiceCreate);



// WEBPACK FOOTER //
// ./src/components/tracker/Invoice/InvoiceCreate.js